import React from 'react';
import { Grid, Table, Pagination, Segment, Button, Icon } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';

const Users = ({
  loading,
  usersList,
  totalPages,
  activePage,
  onPageChange,
  onClickOfDelete,
  history,
  limit,
  totalCount
}) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <Grid centered padded style={{ paddingTop: '8vh', paddingBottom: '12vh' }}>
      <Helmet>
        <title> Users Listing </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Users Listing
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={15} textAlign="center">
          {/* <Button basic color="blue" onClick={() => history.push('/orders_search')}> */}
          <Button floated="left" basic color="blue" onClick={() => history.push('/users/search')}>
            Search Users
            <Icon style={{ marginLeft: '0.5em' }} name="search" />
          </Button>
          <Button
            floated="right"
            icon
            labelPosition="left"
            basic
            color="blue"
            size="small"
            onClick={() => history.push('/users/new')}
          >
            <Icon name="user" /> Add User
          </Button>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={15}>
          <Table celled fixed>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No.</Table.HeaderCell>
                <Table.HeaderCell>User Id</Table.HeaderCell>
                <Table.HeaderCell>Mobile</Table.HeaderCell>
                <Table.HeaderCell>Full Name</Table.HeaderCell>
                <Table.HeaderCell>Role</Table.HeaderCell>
                <Table.HeaderCell>Email</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Last Login</Table.HeaderCell>
                <Table.HeaderCell>Join Date</Table.HeaderCell>
                <Table.HeaderCell>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {usersList &&
                usersList.length &&
                usersList.map((el, index) => (
                  <Table.Row key={el.id}>
                    <Table.Cell>{index + 1}</Table.Cell>
                    <Table.Cell>{el.id}</Table.Cell>
                    <Table.Cell>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <Link
                        // to={`/users/details/${el.id}`}
                        to="#"
                        style={{
                          textDecoration: 'underline',
                          color: '#603cba'
                        }}
                      >
                        {el.mobile}
                      </Link>
                    </Table.Cell>
                    <Table.Cell>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <Link
                        // to={`/users/details/${el.id}`}
                        to="#"
                        style={{
                          textDecoration: 'underline',
                          color: '#603cba'
                        }}
                      >
                        {el.full_name}
                      </Link>
                    </Table.Cell>
                    <Table.Cell>{el.user_role || 'N/A'}</Table.Cell>
                    <Table.Cell>{el.email || 'N/A'}</Table.Cell>
                    <Table.Cell>{el.status}</Table.Cell>
                    <Table.Cell>
                      {el.last_login
                        ? moment
                            .utc(el.last_login)
                            .local()
                            .format('DD-MM-YYYY HH:mm:ss')
                        : 'N/A'}
                    </Table.Cell>
                    <Table.Cell>
                      {/* {new Date(el.created_at).toLocaleString()} */}
                      {moment
                        .utc(el.since)
                        .local()
                        .format('DD-MM-YYYY')}
                    </Table.Cell>
                    <Table.Cell>
                      <Button disabled basic icon color="blue">
                        <Icon name="pencil" />
                      </Button>
                      <Button
                        onClick={() => onClickOfDelete(el.full_name, el.id)}
                        basic
                        icon
                        color="red"
                      >
                        <Icon name="delete" />
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
      {totalCount > limit ? (
        <Grid.Row centered>
          <Grid.Column width={5}>
            <Pagination
              defaultActivePage={activePage}
              totalPages={Math.floor(totalPages)}
              style={{ marginBottom: '5vh' }}
              onPageChange={onPageChange}
            />
          </Grid.Column>
        </Grid.Row>
      ) : null}
    </Grid>
  );
};

export default withRouter(Users);



// WEBPACK FOOTER //
// ./src/Modules/UsersList/component.jsx